import SpinnerLoading from '@/assets/spinner.svg'

interface SpinnerProps {
  className?: string
}

export function Spinner(props: SpinnerProps) {
  const { className } = props

  return (
    <div className="w-full" data-testid="spinner">
      <img src={SpinnerLoading} className={`${className} mx-auto`} alt="loading spinner" />
    </div>
  )
}
